import { render } from "./Toaster.vue?vue&type=template&id=2f863d89&scoped=true&ts=true"
import script from "./Toaster.vue?vue&type=script&lang=ts"
export * from "./Toaster.vue?vue&type=script&lang=ts"

import "./Toaster.vue?vue&type=style&index=0&id=2f863d89&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Xabie\\OneDrive\\Desktop\\Proyectos\\Dream\\web\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f863d89"]])

export default __exports__